import React from "react";
import { validationUtils } from "../validation/Validation";
import { IDriver, IViolationList, IIncidentInfo } from "../classes/Domain";
import Select, { ValueType, ActionMeta } from "react-select";
import { Form, Row, Col, Button } from 'react-bootstrap';
import { QUOTE_QUESTIONS } from "../AppConstants";

type SelectOption = {
    value: string,
    label: string
}

interface IState {
    ageOptions: Array<SelectOption>,
    selectedAgeOption: SelectOption | null,
    genderOptions: Array<SelectOption>,
    selectedGenderOption: SelectOption | null,
    maritalOptions: Array<SelectOption>,
    selectedMaritalOption: SelectOption | null,
    licenseStatusOptions: Array<SelectOption>,
    selectedLicenseStatusOption: SelectOption | null,
    violationOptions: Array<SelectOption>,
    selectedViolationOption: SelectOption | null,
    driver: IDriver,
    propsMerged: boolean;
}

interface IProps {
    updatingStore?: boolean,
    violationList: IViolationList,
    driver: IDriver,
    driverIndex: number,
    errors: any,
    onDriverChange(driver: IDriver, index: number): void;
    onDriverDelete(index: number): void;
}

class DriverPart extends React.Component<IProps, IState> {
    selectAgeRef: React.RefObject<Select>;
    selectGenderRef: React.RefObject<Select>;
    selectMaritalStatusRef: React.RefObject<Select>;
    selectLicenseStatusRef: React.RefObject<Select>;
    selectVialationsRef: React.RefObject<Select>;

    constructor(props: IProps) {
        super(props);
        this.selectAgeRef = React.createRef();
        this.selectGenderRef = React.createRef();
        this.selectMaritalStatusRef = React.createRef();
        this.selectLicenseStatusRef = React.createRef();
        this.selectVialationsRef = React.createRef();

        this.onAgeChange = this.onAgeChange.bind(this);
        this.onGenderChange = this.onGenderChange.bind(this);
        this.onMaritalChange = this.onMaritalChange.bind(this);
        this.onLicenseStatusChange = this.onLicenseStatusChange.bind(this);
        this.onViolationChange = this.onViolationChange.bind(this);

        this.state = {
            ageOptions: [],
            selectedAgeOption: null,
            genderOptions: [],
            selectedGenderOption: null,
            maritalOptions: [],
            selectedMaritalOption: null,
            licenseStatusOptions: [],
            selectedLicenseStatusOption: null,
            violationOptions: [],
            selectedViolationOption: null,
            driver: this.props.driver,
            propsMerged: false
        };
    }

    componentDidMount() {
        const _ageOptions: Array<SelectOption> = [];
        for (let i = 18; i <= 99; i++) {
            _ageOptions.push({ label: i.toString(), value: i.toString() } as SelectOption);
        }

        const _genderOptions: Array<SelectOption> = [
            { label: "Male", value: QUOTE_QUESTIONS.ABOUT_YOU.GENDER.MALE },
            { label: "Female", value: QUOTE_QUESTIONS.ABOUT_YOU.GENDER.FEMALE }
        ];

        const _maritalOptions: Array<SelectOption> = [
            { label: "Single", value: QUOTE_QUESTIONS.ABOUT_YOU.MARITAL_STATUS.SINGLE },
            { label: "Married", value: QUOTE_QUESTIONS.ABOUT_YOU.MARITAL_STATUS.MARRIED }
        ];

        const _licenseStatusOptions: Array<SelectOption> = [
            { label: "Active", value: QUOTE_QUESTIONS.YOUR_LICENSE.CURRENT_LICENSE_STATUS.ACTIVE },
            { label: "Learners Permit", value: QUOTE_QUESTIONS.YOUR_LICENSE.CURRENT_LICENSE_STATUS.LEARNERS_PERMIT },
            { label: "ID Card", value: QUOTE_QUESTIONS.YOUR_LICENSE.CURRENT_LICENSE_STATUS.ID_CARD },
            { label: "Suspended", value: QUOTE_QUESTIONS.YOUR_LICENSE.CURRENT_LICENSE_STATUS.SUSPENDED }
            //{ label: "Revoked", value: QUOTE_QUESTIONS.YOUR_LICENSE.CURRENT_LICENSE_STATUS.REVOKED },
            //{ label: "Expired", value: QUOTE_QUESTIONS.YOUR_LICENSE.CURRENT_LICENSE_STATUS.EXPIRED }
        ]

        const _violationsOption: Array<SelectOption> = [
            { label: "No", value: QUOTE_QUESTIONS.YES_NO.NO },
            { label: "Yes", value: QUOTE_QUESTIONS.YES_NO.YES }
        ];

        this.setState({
            ...this.state,
            ageOptions: _ageOptions,
            genderOptions: _genderOptions,
            maritalOptions: _maritalOptions,
            licenseStatusOptions: _licenseStatusOptions,
            violationOptions: _violationsOption
        });
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (prevState.propsMerged) return prevState;
        const driver = nextProps.driver as IDriver;

        if (driver) {
            const _selectedAgeOption = driver.age > 0
                ? { label: driver.age.toString() + " Years Old", value: driver.age.toString() } as SelectOption
                : prevState.selectedAgeOption;

            const _selectedGenderOption = driver.gender
                ? { label: driver.gender, value: driver.gender } as SelectOption
                : prevState.selectedGenderOption;

            const _selectedMaritalOption = driver.maritalStatus
                ? { label: driver.maritalStatus, value: driver.maritalStatus } as SelectOption
                : prevState.selectedMaritalOption;

            const _selectedLicenseStatusOption = driver.currentLicenseStatus
                ? { label: driver.currentLicenseStatus, value: driver.currentLicenseStatus } as SelectOption
                : prevState.selectedlicenseStatusOption;

            const _selectedViolationOption = driver.accidentsViolations
                ? { label: driver.accidentsViolations, value: driver.accidentsViolations } as SelectOption
                : prevState.selectedViolationOption;

            const nextState = {
                ...prevState,
                driver: driver,
                selectedAgeOption: _selectedAgeOption,
                selectedGenderOption: _selectedGenderOption,
                selectedMaritalOption: _selectedMaritalOption,
                selectedLicenseStatusOption: _selectedLicenseStatusOption,
                selectedViolationOption: _selectedViolationOption,
                propsMerged: true
            };

            return nextState;
        }

        return prevState;
    }

    onAgeChange(newValue: ValueType<any>, action: ActionMeta<SelectOption>) {
        const _age = parseInt(newValue.value, 10);
        const updatedDriver = { ...this.state.driver, age: _age };
        this.setState({ ...this.state, driver: updatedDriver, selectedAgeOption: newValue }, () => {
            this.props.onDriverChange(updatedDriver, this.props.driverIndex);
        });
    }

    onGenderChange(newValue: ValueType<any>, action: ActionMeta<SelectOption>) {
        const _gender = newValue.value;
        const updatedDriver = { ...this.state.driver, gender: _gender };
        this.setState({ ...this.state, driver: updatedDriver, selectedGenderOption: newValue }, () => {
            this.props.onDriverChange(updatedDriver, this.props.driverIndex);
        });
    }

    onMaritalChange(newValue: ValueType<any>, action: ActionMeta<SelectOption>) {
        const _maritalStatus = newValue.value;
        const updatedDriver = { ...this.state.driver, maritalStatus: _maritalStatus };
        this.setState({ ...this.state, driver: updatedDriver, selectedMaritalOption: newValue }, () => {
            this.props.onDriverChange(updatedDriver, this.props.driverIndex);
        });
    }

    onLicenseStatusChange(newValue: ValueType<any>, action: ActionMeta<SelectOption>) {
        const _licenseStatus = newValue.value;
        const updatedDriver = { ...this.state.driver, currentLicenseStatus: _licenseStatus };
        this.setState({ ...this.state, driver: updatedDriver, selectedLicenseStatusOption: newValue }, () => {
            this.props.onDriverChange(updatedDriver, this.props.driverIndex);
        });
    }

    onViolationChange(newValue: ValueType<any>, action: ActionMeta<SelectOption>) {
        const _accidentsViolations = newValue.value;
        let updatedDriver = { ...this.state.driver, accidentsViolations: _accidentsViolations, incidents: new Array<IIncidentInfo>() };

        if (_accidentsViolations === QUOTE_QUESTIONS.YES_NO.YES) {
            let incendent: IIncidentInfo = {
                category: "",
                violation: "",
                violationCode: "",
                violationDate: new Date(),
                convictionDate: null
            };

            updatedDriver.incidents.push(incendent);
        }

        this.setState({ ...this.state, driver: updatedDriver, selectedViolationOption: newValue }, () => {
            this.props.onDriverChange(updatedDriver, this.props.driverIndex);
        });
    }

    render() {
        return (
            <div className="vehicle-row">
                <Row>
                    <Col sm={2}>
                        <Select
                            ref={this.selectAgeRef}
                            options={this.state.ageOptions}
                            value={this.state.selectedAgeOption}
                            placeholder={"AGE..."}
                            onChange={this.onAgeChange}
                            isSearchable={true}
                            autoFocus={false}
                            isClearable={false}
                            openMenuOnFocus={true}
                            isDisabled={this.props.updatingStore}
                        />
                        {
                            null != this.props.errors && (!this.state.driver?.age || this.state.driver.age === 0) && validationUtils.hasValidationErrorFor(this.props.errors, "driver.age")
                                ? <Form.Control.Feedback type="invalid">
                                    {validationUtils.getValidationErrorFor(this.props.errors, "driver.age")}
                                </Form.Control.Feedback>
                                : null
                        }
                    </Col>
                    <Col sm={2}>
                        <Select
                            ref={this.selectGenderRef}
                            options={this.state.genderOptions}
                            value={this.state.selectedGenderOption}
                            placeholder={"Gender..."}
                            onChange={this.onGenderChange}
                            isSearchable={true}
                            autoFocus={false}
                            isClearable={false}
                            openMenuOnFocus={true}
                            isDisabled={this.props.updatingStore}
                        />
                        {
                            null != this.props.errors && !this.state.driver?.gender && validationUtils.hasValidationErrorFor(this.props.errors, "driver.gender")
                                ? <Form.Control.Feedback type="invalid">
                                    {validationUtils.getValidationErrorFor(this.props.errors, "driver.gender")}
                                </Form.Control.Feedback>
                                : null
                        }
                    </Col>
                    <Col sm={2}>
                        <Select
                            ref={this.selectMaritalStatusRef}
                            options={this.state.maritalOptions}
                            value={this.state.selectedMaritalOption}
                            placeholder={"Marital Status..."}
                            onChange={this.onMaritalChange}
                            isSearchable={true}
                            autoFocus={false}
                            isClearable={false}
                            openMenuOnFocus={true}
                            isDisabled={this.props.updatingStore}
                        />
                        {
                            null != this.props.errors && !this.state.driver?.maritalStatus && validationUtils.hasValidationErrorFor(this.props.errors, "driver.maritalStatus")
                                ? <Form.Control.Feedback type="invalid">
                                    {validationUtils.getValidationErrorFor(this.props.errors, "driver.maritalStatus")}
                                </Form.Control.Feedback>
                                : null
                        }
                    </Col>
                    <Col sm={2}>
                        <Select
                            ref={this.selectLicenseStatusRef}
                            options={this.state.licenseStatusOptions}
                            value={this.state.selectedLicenseStatusOption}
                            placeholder={"License Status..."}
                            onChange={this.onLicenseStatusChange}
                            isSearchable={true}
                            autoFocus={false}
                            isClearable={false}
                            openMenuOnFocus={true}
                            isDisabled={this.props.updatingStore}
                        />
                        {
                            null != this.props.errors && !this.state.driver?.currentLicenseStatus && validationUtils.hasValidationErrorFor(this.props.errors, "driver.currentLicenseStatus")
                                ? <Form.Control.Feedback type="invalid">
                                    {validationUtils.getValidationErrorFor(this.props.errors, "driver.currentLicenseStatus")}
                                </Form.Control.Feedback>
                                : null
                        }
                    </Col>
                    <Col sm={3}>
                        <Select
                            ref={this.selectVialationsRef}
                            options={this.state.violationOptions}
                            value={this.state.selectedViolationOption}
                            placeholder={"Violations Last 3 Yrs..."}
                            onChange={this.onViolationChange}
                            isSearchable={true}
                            autoFocus={false}
                            isClearable={false}
                            openMenuOnFocus={true}
                            isDisabled={this.props.updatingStore}
                        />
                        {
                            null != this.props.errors && !this.state.driver?.incidents && validationUtils.hasValidationErrorFor(this.props.errors, "driver.accidentsViolations")
                                ? <Form.Control.Feedback type="invalid">
                                    {validationUtils.getValidationErrorFor(this.props.errors, "driver.accidentsViolations")}
                                </Form.Control.Feedback>
                                : null
                        }
                    </Col>
                    <Col sm={1}>
                        {
                            this.props.driverIndex > 0
                                ?
                                <Button
                                    className="btn-remove"
                                    onClick={() => { this.props.onDriverDelete(this.props.driverIndex) }}
                                    disabled={this.props.updatingStore}>
                                    <i className="fas fa-trash"></i>
                                </Button>
                                :
                                null
                        }
                    </Col>
                </Row>
            </div>
        );
    }
}

export default DriverPart